import { CardType, ICardList } from '../types/CardList';

export const cardList = (item?: ICardList) => ({
  id: item?.id ?? 0,
  last_numbers: item?.last_numbers ?? '',
  title: item?.title ?? '',
  ps: item?.ps ?? CardType.UZCARD,
});
export const cardListMapper = (item?: ICardList[]) => item?.map(cardList) ?? [];
